import { Close, Search as SearchIcon, Language } from "@material-ui/icons"
import { useEffect, useState } from "react";
import Bitcou from "../lib/Bitcou";
import axios from "axios";
import { IPDATA_KEY } from "../Env";
import Currencies from "../lib/Currencies";
import { useHistory } from "react-router-dom";

const Search = ({ onSearchClose }) => {
    
    let searchTimeout, userCountry;

    const history = useHistory();
    
    const [search, setSearch] = useState();
    const [country, setCountry] = useState();
    const [brands, setBrands] = useState();
    
    const close = () => onSearchClose(false);
    
    const onSearchChange = ({ target }) => {
        
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            setSearch(target.value)
        }, 1000)
    }
    
    const ignoreCountry = () => {
        setCountry();
        Bitcou.searchBrands(search, null, 5)
        .then((data) => setBrands(data));
    }
    
    const getUserCountry = (list) => {
        axios.get("https://api.ipdata.co?api-key=" + IPDATA_KEY)
        .then(({ data }) => {
            userCountry = data.country_code;
            setCountry(data.country_code);
        });
    }
    
    const price = (brand) => {
        const product = brand.products[0];
        return (product.isVariablePrice ? 'Starting at ' + product.minVariablePrice : product.fixedPrice) + " " + Currencies.GetSymbol(product.currency);
    }

    useEffect(getUserCountry, [])

    useEffect(() => {
        if (!search) {
            setBrands(null)
            return;
        }
        Bitcou.searchBrands(search, country, 5)
            .then((data) => setBrands(data));
    }, search)

    const goToProduct = (brand) => {
        history.push("/products/" + brand.variantID)
        onSearchClose();
    }

    return (
        <div className="search-overlay">
            <div className="search-content">
                <div>
                    <div class="search-input input-group mb-3">
                        <input type="text" placeholder="Search product..." onChange={onSearchChange} />
                        <div class="input-group-append">
                            <SearchIcon />
                        </div>
                    </div>
                </div>
                <div className="search-results">
                    {brands && brands.map((brand) => (
                        <div key={brand.variantID} className="search-item" onClick={() => goToProduct(brand)}>
                            <img src={brand.brandImageURL}/>
                            <div>
                                <div className="search-label">{brand.brandName}</div>
                                <div className="search-label text-muted">{price(brand)}</div>
                            </div>
                        </div>
                    ))}
                </div>
                {brands != null && brands.length == 0 && country != null && (
                    <div className="search-empty">
                        <p className="text-center open-font-condensed">
                            Could not find products related to your search in your country
                        </p>
                        <div className="text-center">
                            <button className="btn-black" onClick={ignoreCountry}>
                                <Language /> Search in all countries
                            </button>
                        </div>
                    </div>
                )}
                {brands != null && brands.length == 0 && country == null && (
                    <div className="search-empty">
                        <p className="text-center open-font-condensed">
                            Could not find products related to your search
                        </p>
                    </div>
                )}
            </div>
            
            <button className="close-btn" onClick={close}>
                <Close fontSize="large" />
                <span>Close</span>
            </button>
        </div>
    )
}

export { Search }